import React, { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import {
  defaultStyle,
  invertedStyle,
  secondaryStyle,
  tertiaryStyle,
  transparentStyle,
  borderStyle,
} from './link-styles'

interface Props {
  children: ReactElement | string
  inverted?: boolean
  secondary?: boolean
  tertiary?: boolean
  transparent?: boolean
  border?: boolean
  to?: string
  onClick?: () => void
}

const LinkButton: React.FC<Props> = ({
  children,
  inverted = false,
  secondary = false,
  to,
  onClick,
  transparent = false,
  tertiary = false,
  border = false,
}) => {
  const styles =
    (secondary && secondaryStyle) ||
    (inverted && invertedStyle) ||
    (transparent && transparentStyle) ||
    (tertiary && tertiaryStyle) ||
    (border && borderStyle) ||
    defaultStyle

  const handleShowHeader = () => {
    const topHeader = document.querySelector('#top-header')
    const progressHeader = document.querySelector('#progress-header')

    topHeader?.classList.remove('scrolled')
    progressHeader?.classList.remove('scrolled')
  }

  if (!to) {
    return (
      <Button
        sx={[styles]}
        fullWidth
        variant="contained"
        onClick={() => {
          handleShowHeader()
          onClick && onClick()
        }}
      >
        {children}
      </Button>
    )
  }
  if (/^https?:\/\//.test(to)) {
    return (
      <Button
        sx={[styles]}
        href={to}
        fullWidth
        variant="contained"
        onClick={() => {
          handleShowHeader()
          onClick && onClick()
        }}
        component={(props: any) => <a {...props} />}
      >
        {children}
      </Button>
    )
  }
  return (
    <Button
      sx={[styles]}
      to={to}
      fullWidth
      variant="contained"
      onClick={() => {
        handleShowHeader()
        onClick && onClick()
      }}
      component={Link}
    >
      {children}
    </Button>
  )
}

export default LinkButton
